import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {
  Grid,
  Box as MuiBox,
  Button as MuiButton,
  Typography,
} from '@mui/material';

const ComplianceCard = ({
  bgColor,
  onClick,
  icon,
  title,
  mainText,
  linkText,
  // size,
}: any) => {
  return (
    <Grid
      item
      xs={12}
      md={5}
      padding={3}
      margin={1}
      bgcolor={bgColor}
      onClick={onClick}
      sx={{ cursor: linkText && 'pointer' }}
      textAlign="left"
      position="relative"
      borderRadius={1}
    >
      <Grid container spacing={3} direction="column">
        {icon && (
          <Grid item>
            <img src={icon} alt="" height={50} />
          </Grid>
        )}
        {title && (
          <Grid item>
            <Typography variant='h5'>
              {title}
            </Typography>
          </Grid>
        )}
        {mainText && (
          <Grid item mt="sm">
            <Typography variant='body1'>
              {mainText}
            </Typography>
          </Grid>
        )}
        {linkText && (
          <Grid item marginBottom={4}>
            <MuiBox position="absolute" sx={{ bottom: 10 }}>
              <MuiButton>
                <Typography variant="button">
                  {linkText}
                </Typography>
                <ArrowRightAltIcon />
              </MuiButton>
            </MuiBox>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ComplianceCard;
